import { Button } from '@teach/ui'
import { SUPPORT_BOT_URL } from '@/features/support/supportLinks'
import { useLanguage } from '@/hooks/useLanguage'
import mascot from '@/assets/sad-maskot.svg'
import { rateLimitT } from './locale'

export const RateLimitBanScreen = () => {
  const { language } = useLanguage()
  const l = rateLimitT[language]

  return (
    <div className="flex min-h-dvh items-center justify-center p-4">
      <div className="flex max-w-md flex-col items-center text-center">
        <img src={mascot} alt="" className="mb-6 h-48 w-48 object-contain" />
        <h1 className="mb-2 text-2xl font-bold">{l.title}</h1>
        <p className="mb-6 text-muted-foreground">{l.description}</p>
        <div className="flex flex-wrap justify-center gap-3">
          <Button asChild>
            <a href={SUPPORT_BOT_URL} target="_blank" rel="noreferrer">
              {l.support}
            </a>
          </Button>
          <Button variant="outline" onClick={() => window.location.reload()}>
            {l.retry}
          </Button>
        </div>
      </div>
    </div>
  )
}
